// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n*[data-v-e835979c] .custom-table {\n\tborder: 1px solid var(--main-gray-2);\n\tmin-height: auto;\n}\n*[data-v-e835979c] .custom-table tr.selected {\n\tbackground: var(--main-light-blue);\n\tcolor: var(--main-blue-3);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
